import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a PDF icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/file-pdf?f=classic&s=solid
 */
export const PDFIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faFilePdf} {...props} />;
};
